import callApi from './crmService';

const webPath = `/web/${process.env.VUE_APP_COMPANY_KEY}`;
const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}`;
export const getShopDetail = () => callApi({
    method: 'GET',
    endpoint: `${basePath}/pos/trade-detail`
  });

export const getBackendTagByMobile = (mobile) => callApi({
  method: 'GET',
  endpoint: `${basePath}/member-card/tags?mobile=${mobile}`
});

export const getPosData = (mobile) => callApi({
  method: 'GET',
  endpoint: `${basePath}/pos/member-card`
});

